(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-atc-sizes"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__cardAtcInit) return;
    window.__cardAtcInit = true;

    /* Secciones de carrito presentes en la página (drawer, página de carrito):
       Shopify las devuelve ya renderizadas en la misma respuesta del add, y el
       tema las usa para refrescar el drawer sin pedir otra vuelta al servidor. */
    function cartSectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el) {
        var id = el.dataset.sectionId;
        if (id && ids.indexOf(id) < 0) ids.push(id);
      });
      return ids;
    }

    /* El tema escucha 'cart:update' en document (ThemeEvents.cartUpdate): de ahí
       viven el contador de la burbuja y la apertura automática del drawer. El
       evento 'cart:refresh' que había antes no lo escuchaba nadie, por eso el
       icono del carrito no se enteraba de nada. */
    function announce(cart, added) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'card-atc',
          data: {
            source: 'card-atc',
            itemCount: cart.item_count,
            productId: added && added.product_id ? String(added.product_id) : undefined,
            variantId: added && added.variant_id ? String(added.variant_id) : undefined,
            sections: added ? added.sections : undefined
          }
        }
      }));
      window.dispatchEvent(new Event('cart:refresh'));
    }

    function addToCart(variantId, btn, onDone) {
      if (!variantId) return;
      btn.disabled = true;

      var body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');

      var ids = cartSectionIds();
      if (ids.length) {
        body.append('sections', ids.join(','));
        body.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
      .then(function(r) { return r.json(); })
      .then(function(added) {
        /* Shopify responde 422 con status/description cuando no hay stock */
        if (added && added.status) throw new Error(added.description || added.message);
        return fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            announce(cart, added);
            if (onDone) onDone(true);
          });
      })
      .catch(function() {
        if (onDone) onDone(false);
      });
    }

    document.addEventListener('click', function(e) {
      /* Size button — add to cart immediately */
      var sizeBtn = e.target.closest('.card-atc__size');
      if (sizeBtn && !sizeBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        var wrap = sizeBtn.closest('.card-atc');
        var origText = sizeBtn.textContent.trim();

        wrap.querySelectorAll('.card-atc__size--active').forEach(function(b) {
          b.classList.remove('card-atc__size--active');
        });
        sizeBtn.classList.add('card-atc__size--active');
        sizeBtn.textContent = '...';

        addToCart(sizeBtn.dataset.variantId, sizeBtn, function(ok) {
          sizeBtn.textContent = ok ? '\u2713' : origText;
          if (ok) sizeBtn.classList.add('card-atc__size--added');
          setTimeout(function() {
            sizeBtn.textContent = origText;
            sizeBtn.classList.remove('card-atc__size--active', 'card-atc__size--added');
            sizeBtn.disabled = false;
          }, 1200);
        });
        return;
      }

      /* ATC Button (only for products WITHOUT sizes) */
      /* «AVÍSAME» (agotado) lo atiende klaviyo-bis-modal.liquid */
      var atcBtn = e.target.closest('.card-atc__btn:not(.card-atc__btn--notify)');
      if (atcBtn && !atcBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();

        atcBtn.classList.add('card-atc__btn--loading');

        /* Se guarda la etiqueta que traía: ahora es configurable por sección,
           así que al restaurar no se puede escribir un texto fijo. */
        var textEl = atcBtn.querySelector('.card-atc__btn-text');
        var origLabel = atcBtn.dataset.label || textEl.textContent.trim();
        atcBtn.dataset.label = origLabel;

        addToCart(atcBtn.dataset.variantId, atcBtn, function(ok) {
          atcBtn.classList.remove('card-atc__btn--loading');
          if (ok) {
            atcBtn.classList.add('card-atc__btn--added');
            textEl.textContent = 'AGREGADO';
          } else {
            textEl.textContent = 'ERROR';
          }
          setTimeout(function() {
            atcBtn.classList.remove('card-atc__btn--added');
            textEl.textContent = origLabel;
            atcBtn.disabled = false;
          }, 1500);
        });
      }
    });

    /* Move card-atc inside the gallery */
    function moveSizesToGallery() {
      document.querySelectorAll('.card-atc:not([data-moved])').forEach(function(atc) {
        var card = atc.closest('product-card') || atc.closest('.product-card');
        if (!card) return;
        var gallery = card.querySelector('.card-gallery');
        if (gallery) {
          gallery.style.position = 'relative';
          gallery.appendChild(atc);
          atc.dataset.moved = '1';
        }
      });
    }
    /* Debounce: el observer escucha TODO el <body>, asi que sin esto
       moveSizesToGallery corria en cada mutacion del DOM (lazy images,
       refresh de carrito...). Con requestAnimationFrame las
       rafagas de mutaciones colapsan a una sola llamada por frame. */
    var moveScheduled = false;
    function scheduleMoveSizes() {
      if (moveScheduled) return;
      moveScheduled = true;
      requestAnimationFrame(function() {
        moveScheduled = false;
        moveSizesToGallery();
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', moveSizesToGallery);
    } else {
      moveSizesToGallery();
    }
    new MutationObserver(scheduleMoveSizes).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
